export { BankAccountApi } from './api/bank-account.api'
export type { BankAccount, BankAccountLastMovement } from './model/bank-account.model'
